/**
 * Upstream PHP2Shell fixed releases.
 * Update this module when the PHP project publishes a new advisory.
 * This scanner is not the source of truth.
 */
export const ADVISORY_DATA_REVIEWED_AT = '2026-10-24T00:00:00.000Z';

export interface FixedRelease {
  branch: string;
  version: string;
}

export const FIXED_RELEASES: readonly FixedRelease[] = [
  { branch: '8.2', version: '8.2.35' },
  { branch: '8.3', version: '8.3.36' },
  { branch: '8.4', version: '8.4.27' },
  { branch: '8.5', version: '8.5.12' },
] as const;

export const FIXED_RELEASE_BY_BRANCH: ReadonlyMap<string, string> = new Map(
  FIXED_RELEASES.map((release) => [release.branch, release.version]),
);

export interface AdvisoryLink {
  id: string;
  label: string;
  url: string;
}

export const PHP2SHELL_CVES: readonly AdvisoryLink[] = [
  {
    id: 'CVE-2026-109618',
    label: 'CVE-2026-109618 — PHP2Shell out-of-memory corruption',
    url: 'https://github.com/php/php-src/security/advisories/GHSA-w8hw-w9fx-j79w',
  },
  {
    id: 'CVE-2026-109619',
    label: 'CVE-2026-109619 — PHP2Shell stale global state',
    url: 'https://github.com/php/php-src/security/advisories/GHSA-6wmf-4rv5-p3rp',
  },
] as const;

export const OFFICIAL_ADVISORIES: readonly AdvisoryLink[] = [
  {
    id: 'php-advisory',
    label: 'PHP security advisory (21 October 2026)',
    url: 'https://www.php.net/archive/2026.php#2026-10-21-5',
  },
  ...PHP2SHELL_CVES,
] as const;

export const SUPPORTED_FIXED_VERSION_LIST = FIXED_RELEASES.map((release) => release.version).join(', ');

export const DISCLAIMER =
  'This assessment is based on publicly observable HTTP evidence. It does not execute an exploit, inspect the server\'s actual runtime, or verify installed security patches. Confirm the result directly on the server or through your hosting provider.';

export const NO_EVIDENCE_SUMMARY =
  'No public PHP evidence was found in this scan. This does not prove that the website does not use PHP or that it is not vulnerable.';
